import { useEffect, useState, useMemo, Suspense, useRef } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { BrowserRouter, Route, Switch, Link, NavLink, useHistory, useParams, useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { blue } from '@mui/material/colors';
import VideoLabelRoundedIcon from '@mui/icons-material/VideoLabelRounded';
import AudiotrackRoundedIcon from '@mui/icons-material/AudiotrackRounded';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import { Grid, Box, Container, Typography, Pagination } from '@mui/material'
import { format } from 'date-fns'

import { Sound, Movie, File, MultiLineBody } from '../utils/util'
import { CONFIG } from '../states/settings'
import '../../assets/css/index.css'


/*
 *  TODO: 
 *  ページ番号はURLからとっているが、コントローラーから引数で受け取るほうがいいかも
 */
const Items = (props) => {
  let json_file = props.json_file || null;
  let menu_id   = props.menu_id   || null;
  let limit     = props.limit     ?  props.limit    : CONFIG.LIMIT_PER_PAGE
  let use_pager = props.use_pager ?  true           : false
  let use_grid  = props.use_grid  ?  true           : false
  let show_full = props.show_full ?  true           : false
  let from_url  = props.from_url  ?  props.from_url : '/'
  let ui = useLocation()
  let from_entry_id = ui.state ? (ui.state.from_entry_id ? ui.state.from_entry_id : null) : null

  let { id, pagenum } = useParams()
  pagenum = isNaN(pagenum) ? 1 : pagenum
  pagenum--

  let [ items, setItems] = useState([])
  let [ pageCount, setPageCount ] = useState(1)

  let node_selected = useRef(null)

  // invoke url change
  let history = useHistory()


  useEffect(() => {
    if ( !json_file ) return;
  
    (async () => {
      let url =  CONFIG.API.INFO + json_file.split('.')[0] + CONFIG.API.INFO_EX
      let response = await fetch(url);
      let json = await response.json()

      let data = json.messages
      setItems(data)

      // total page number
      let page_count = Math.ceil(data.length / limit)
      setPageCount(page_count)

      // jump y-position pre-readed item
      if (node_selected && node_selected.current && node_selected.current.offsetTop) {
        window.scrollTo(0, node_selected.current.offsetTop)
      }
    })();
  }, [json_file])

  let render_per_page = ()=>{
    let head = pagenum*limit, tail = head + limit
    let feed = items.slice(head, tail)

    let render_full = ()=>{
      return (
        <Box className='item_list_area'>
          <Grid container alignitems="baseline" spacing={2}>
            { feed.map((v,i) => {
              let looked_article = (v.id == from_entry_id) ? 'looked_article' : ''

              return (
                <Grid item sm={12} md={12} lg={12} xl={12}>
                  <Box
                    ref={looked_article ? node_selected : null}
                    className={`item_wrapper ${looked_article} ${v.is_emergency ? 'emergency' : ''}`}
                    pt='.7rem' pr='.7rem' pl='.7rem' pb='1.4rem'
                    sx={{
                      // height: '100%',
                      boxShadow: 2, bgcolor: '#fafafa', alignItems: 'stretch',
                      '&:hover': {
                        backgroundColor: blue[100],
                      }
                    }}>
                  <Link to={{
                    pathname: `${CONFIG.PAGE_ROOT_PATH}/${menu_id}/items/${v.id}`,
                    state: {
                      from_url: from_url,
                      page_limit: limit,
                    }
                  }}>
                    <Typography component="h4" variant="h6" fontWeight='600' mb='.25rem' sx={{lineHeight:'1.3'}}>
                      { v.title }
                    </Typography>

                    <Grid className='item_list_other' container mb='1rem'>
                      <p className='sender_name'>{ v.sender_name }</p>
                      <time className='time_c1' datetime="{ format(new Date(v.sent_at),'yyyy-MM-dd HH:mm')">
                        { format(new Date(v.sent_at),'yyyy-MM-dd HH:mm') }
                      </time>
                    </Grid>

                    {/* <Sound v={ v.sound_file } /> */}

                    <Typography className='mabiku' component="p" variant="h7" mb='.7rem' sx={{ fontSize: '.9rem' }}>
                      {/* <MultiLineBody body={v.body} /> */}
                      { v.body }
                    </Typography>
                    {/* <p>IS_EMERGENCY: { v.is_emergency.toString() }</p> */}
                    {/* <p>MOVIE: { v.generated_sound_file }</p> */}
                    {/* <p>TYPE: { v.type }</p> */}
                    <Box 
                      sx={{
                        position: 'absolute',
                        bottom: '.0rem',
                        left: '.5rem',
                      }}>
                      { (v.sound_file || v.generated_sound_file) && <AudiotrackRoundedIcon style={{marginRight:'5px'}} /> }
                      { v.movie_url  && <VideoLabelRoundedIcon style={{marginRight:'5px'}}  /> }
                      { v.file       && <AttachFileRoundedIcon /> }
                    </Box>
                  </Link>
                  </Box>
                </Grid>
              )
            }) }
          </Grid>
        </Box>
      )
    }

    let render_short = ()=>{
      return (
        feed.map((v,i) => {
          return (
            <Box
              className={`Top_menu_list ${v.is_emergency ? 'emergency' : ''}`}
              sx={{
                '&:hover': {
                  backgroundColor: blue[300],
                  color: '#fff'
                }
              }}
            >
            <Link to={{
              pathname: `${CONFIG.PAGE_ROOT_PATH}/${menu_id}/items/${v.id}`,
              state: {
                from_url: from_url,
                page_limit: limit,
              }
            }}>
              <time className='time_c1' datetime="{ format(new Date(v.sent_at),'yyyy-MM-dd')">{ format(new Date(v.sent_at),'yyyy年MM月dd日 HH時mm分') }</time>
              <Typography component="p">
                { v.title }
              </Typography>
            </Link>
            </Box>
          )
        })
      )
    }

    if (use_grid) {
      return render_short()
    } else {
      return render_full()
    }
  }

  let onPageChange = (pg_info)=>{
    //console.log('onPageChange',pg_info)
  }

  let onPageActive = (pg_info)=>{
    //console.log('onPageActive',pg_info)
  }

  let onClick = (pg_info)=>{
    let page_to = pg_info.nextSelectedPage + 1
    history.push(`/${menu_id}/${page_to}`)
  }

  let changePage = (info, page) => {
    history.push(`${CONFIG.PAGE_ROOT_PATH}/${menu_id}/${page}`)
  }


  return (
    <>
    {
      render_per_page()
    }

    { use_pager
      &&
        <Box mt='3rem'>
        <Pagination
          className={'custom_pagination_itemlist'}
          count={pageCount}
          defaultPage={pagenum+1}
          siblingCount={2}
          boundaryCount={4}
          size="large"
          variant='text'
          color='info'
          onChange={ changePage }
        />
        </Box>
    }
    </>
  );
}


export default Items;
